module.exports = __webpack_public_path__ + "static/media/MrWalkerStepsOutBookCover.5d7fa7a6.jpg";